<template>
	<section class="promotions">
		<div class="row">
			<div
				v-for="(block, index) in items.slice(0, amount)"
				:key="block.ID"
				data-aos="fade-in"
				data-aos-duration="1500"
				data-aos-once="true"
				:data-aos-delay="index + '00'"
				class="promoblock"
			>
				<div class="content">
					<h2>{{ block.header }}</h2>
					<div v-parse-links v-html="block.content" />
				</div>
				<picture>
					<source v-if="block.imageWebp" :srcset="block.image" type="image/webp" />
					<source :srcset="block.image" />
					<img :src="block.image" :alt="block.imageAlt" class="promo-img" loading="lazy" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.promotions {
	width: 100%;
	padding: 25px 0 50px;
	text-align: center;
	display: flex;
	flex-flow: row wrap;
	background: linear-gradient(180deg, var(--primary-background-color) 60%, var(--cta-color) 40%);

	.promoblock {
		flex-basis: 31%;
		text-decoration: none;
		border-radius: 6px;
		margin: 0 auto;
		position: relative;

		h2 {
			border-top: 1px solid #fff;
			border-bottom: 1px solid #fff;
			padding: 10px 0;
			width: auto;
			display: inline-block;
		}

		.content {
			position: absolute;
			top: 50%;
			left: 10px;
			right: 10px;
			margin-top: -55px;
			text-align: center;
			color: #fff;
			z-index: 2;

			h2,
			h3,
			h2 a,
			h3 a {
				color: #fff;
				margin: 0 0 30px;
			}
		}

		.promo-img {
			opacity: 1;
			width: 100%;
			transition: all 0.3s ease-in-out;
		}

		&::after {
			content: '';
			position: absolute;
			inset: 0;
			background: rgb(0 0 0 / 40%);
			transition: all 0.3s ease-in-out;
		}

		&:hover::after {
			background: rgb(0 0 0 / 20%);
		}
	}
}

@media (max-width: 800px) {
	.promotions .promoblock {
		flex-basis: 100%;
		margin: 10px 0;
	}
}
</style>
